export default class RedirectHelper {
  static shouldRedirectToKids(pathname) {
    const categoryRegex = /^\/categories\/[0-9a-z]+/
    const kidsCategoryRegex = /^\/categories\/(?:(\d+-)?kids)/

    if(kidsCategoryRegex.test(pathname)) {
      return false
    }

    if(pathname === "/kids") {
      return false
    }

    if(pathname === "/") {
      return true
    }

    if(categoryRegex.test(pathname)) {
      return true
    }
  }
}